(function () {
  function openAllFacetDetails(root) {
    var aside = (root || document).querySelector('#main-collection-filters');
    if (!aside) return;

    aside.querySelectorAll('details.facets__disclosure, details.facets__disclosure-vertical')
      .forEach(function (d) {
        d.open = true;
      });
  }

  function boot() {
    // 컬렉션/검색 등 facets가 있는 페이지만
    if (!document.querySelector('#main-collection-filters')) return;

    openAllFacetDetails(document);

    var target = document.querySelector('#main-collection-filters');
    if (!target) return;

    // facets 렌더링(필터 적용)으로 DOM이 바뀌면 다시 펼침
    var obs = new MutationObserver(function () {
      openAllFacetDetails(document);
    });

    obs.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
